module.exports = __webpack_public_path__ + "static/media/8-item-d.ff101377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/8-item-d.jpg
// module id = 1214
// module chunks = 33